<template>
  <div class="stockIndex">
    <!-- 批次和分类 列表 -->
    <div class="batch_box">
      <!-- 批次和分类按钮 -->
      <div class="b_box_tabs">
        <span :class="active == 1?'active br4':'br4'" @click="changeTab(1)">批次</span>
        <span :class="active == 2?'active br4':'br4'" @click="changeTab(2)">其他</span>
      </div>
      <!-- 批次和分类下边切换的模块 -->
      <div class="b_box_tab_con">
        <!-- 批次模块 -->
        <div v-if="active == 1" class="b_box_tab_item b_box_tab_1">
          <div class="b_box_addBtn br4" @click="handleAddBatch">
            <md-icon name="edit" size="sm" ></md-icon>
            <span>新增批次</span> 
          </div>
          <!-- 搜索条 -->
          <div class="list_search brt4">
            <input type="text" v-model="b_listQuery.supplier_name" @input="handleBatchSearch()" placeholder="搜索货主" />
            <span class="icon_search">
              <md-icon name="search" size="sm" color="#888"></md-icon>
            </span>
            <span class="icon_close" v-if="b_listQuery.supplier_name" @click="b_listQuery.supplier_name = '';handleBatchSearch()">
              <md-icon name="close" size="sm" color="#888"></md-icon>
            </span>
          </div>
          <!-- 批次列表 -->
          <div class="b_box_tab_item_list batch_list">
            <md-scroll-view ref="batchScrollView" :scrolling-x="false" @end-reached="handleBatchListMore" manual-init :auto-reflow="true">
                <div :class="item.id == b_active ? 'list_item active':'list_item'" v-for="(item,index) in b_batchList" :key="index" @click="changeBatch(item)">
                  <div class="list_item_name mand-ellipsis">{{item.supplier_name}}</div>
                  <div class="list_item_num">
                    <span>{{item.purchase_num | addZero}}</span>
                    <div class="goods_item_type">
                      <span class="item_type_zy" v-if="item.type == 1">自营</span>
                      <span class="item_type_dm" v-if="item.type == 2">代卖</span>
                    </div>
                  </div>
                </div>
              <md-scroll-view-more :finished-text="b_batchList.length>0?'全部已加载':'暂无数据'" slot="more" :is-finished="b_isFinished"></md-scroll-view-more>
            </md-scroll-view>
          </div>
        </div>
        <!-- 其他模块 -->
        <div v-if="active == 2" class="b_box_tab_item b_box_tab_2">
          <!-- 其他列表 -->
          <div class="b_box_tab_item_list other_list">
            <div :class="o_active == 1 ? 'list_item active':'list_item'" @click="handleSaleFee">
              <div class="list_item_name mand-ellipsis">销售附加费</div>
              <div class="list_item_num">如筐、包装盒等</div>
            </div>
            <div :class="o_active == 2 ? 'list_item active':'list_item'" @click="handleCostFee">
              <div class="list_item_name mand-ellipsis">成本费用  </div>
              <div class="list_item_num">如运费、人工费等</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 右边box -->
    <div class="stock_right_box">
      <batchGoods v-if="active == 1 && b_active" ref="batchGoods" @update="handleUpdateList"></batchGoods>
      <otherFee v-if="active == 2" ref="otherFee"></otherFee>
      <div v-if="active == 1 && !b_active" class="no_data brtl4">暂无数据</div>
    </div>

    <!-- 新增批次模块 -->
    <addBatch ref="stockAddBatch" @finish="handleFinish"></addBatch>
  </div>
</template>

<script>
import {goodsBatch_getList } from "@/api/work/stock";
import batchGoods from './goods/batchGoods'
import otherFee from './other/otherFee'
import addBatch from './addBatch'
export default {
  name: 'stockIndex',
  components:{batchGoods,addBatch,otherFee},
  data(){
    return {
      active:'1',
      /**
       * 左边的参数
       */
      b_isFinished:false,
      b_active:'',
      b_listQuery:{
        page:1,
        pageSize:50,
        supplier_name:''
      },
      b_batchList:[], // 批次列表

      // 其他里的变量
      o_active:1, // 选中的附加费类型

    }
  },
  created(){
    this.getBatchList()
  },
  mounted(){

  },
  methods:{
    // 切换批次或者其他
    changeTab(index) {
      this.active = index 
      this.$nextTick(()=>{
        if(index == 1 && this.b_active ){
          let item = null
          for (let i = 0; i < this.b_batchList.length; i++) {
            const im = this.b_batchList[i];
            if(im.id == this.b_active){item = im}
          }
          if(item){
            this.$refs.batchGoods.showBox(item)
          }else{
            this.$refs.batchGoods.showBox(this.b_batchList[0])
            this.b_active = this.b_batchList[0].id
          }
          this.$refs.batchScrollView.init()
        }
        if(index == 2 && this.o_active ){
          this.$refs.otherFee.showBox(this.o_active)
        }
      })
    },

    /**
     * 批次相关
     */
    // 获取批次数据
    getBatchList() {
      goodsBatch_getList(this.b_listQuery).then(res=>{
        if(res.code == 200){
          if(this.b_listQuery.page == 1) this.b_batchList = []
          this.b_batchList = this.b_batchList.concat(res.data.list)
          if(this.b_batchList.length >= res.data.totalCount || res.data.list.length == 0){
              this.b_isFinished = true;
          }else{
              this.b_isFinished = false;
              this.b_listQuery.page++;
          }
          if(this.b_listQuery.page == 1 && this.b_batchList.length>0){
            this.b_active = this.b_batchList[0].id
            this.$nextTick(()=>{
              this.$refs.batchGoods.showBox(this.b_batchList[0],this.b_batchList[0].goods_data)
            })
          }else{
            this.b_active = ''
          }
          this.$refs.batchScrollView.init()
          this.$refs.batchScrollView.scrollTo(0,0)
        }
      })
    },
    // 加载更多数据
    handleBatchListMore(){
      if (this.b_isFinished) {
        return
      }
      this.$refs.batchScrollView.finishLoadMore()
      this.getBatchList()
    },
    // 切换批次
    changeBatch(item) {
      this.b_active = item.id
      this.$refs.batchGoods.showBox(item)
    },
    
    // 搜索
    handleBatchSearch(){
      this.b_listQuery.page = 1
      this.getBatchList()
    },

    // 点击了新增批次
    handleAddBatch(){
      this.$refs.stockAddBatch.showPop();
    },
    // 新增批次完成
    handleFinish(){
      this.b_listQuery.page = 1
      this.getBatchList()
    },

    // 更新左边列表
    handleUpdateList(){
      this.b_listQuery.page = 1
      this.getBatchList()
    },

    
    /**
     * 其他相关
     */
    // 点击了销售附加费
    handleSaleFee(){
      this.o_active = 1
      this.$refs.otherFee.showBox(this.o_active)
    },
    // 点击了成本费用
    handleCostFee(){
      this.o_active = 2
      this.$refs.otherFee.showBox(this.o_active)
    },
  }
}
</script>

<style lang="less" scoped>
// 库存管理的样式文件
.stockIndex{
    position: relative;
    display: flex;
    height: 100%;
    overflow: hidden;
    .batch_box{
        width: 1.8rem;
        height: calc(100% - 0.1rem);
        margin-left: 0.1rem;
        margin-top: 0.1rem;
        .b_box_tabs{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 0.1rem;
            span{
                width: 0.85rem;
                height: 0.6rem;
                font-size: 0.24rem;
                background-color: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
                text-align: center;
                &.active{
                    background-color: #31B158;
                    color: #fff;
                }
            }
        }
        .b_box_tab_con{
            position: relative;
            height: calc(100% - 0.7rem);
            .b_box_tab_item{
                height: 100%;
                .b_box_addBtn{
                    width: 100%;
                    background-color: #fff;
                    height: 0.56rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #31B158;
                    margin-bottom: 0.1rem;
                    span{
                        margin-left: 0.08rem;
                    }
                }
                .list_search{
                    width: 100%;
                    height: 0.6rem;
                    background-color: #fff;
                    box-shadow: 0 0.02rem 0.04rem 0.01rem rgba(221,221,221,0.5);
                    box-sizing: border-box;
                    padding: 0.1rem;
                    position: relative;
                    z-index: 2;
                    input {
                      line-height: 0.4rem;
                      font-size: 0.2rem;
                      border: none;
                      outline: none;
                      background-color: #e6e6e6;
                      width: 100%;
                      text-indent: 0.4rem;
                    }
                    span.icon_search {
                      position: absolute;
                      left: 0.18rem;
                      top: 0.18rem;
                    }
                    span.icon_close {
                      position: absolute;
                      right: 0.18rem;
                      top: 0.18rem;
                    }
                }
                .b_box_tab_item_list{
                    overflow: hidden;
                    width: 100%;
                    height: calc(100% - 1.26rem );
                    background-color: #fff;
                    &.other_list{
                      height: 100%;
                    }
                    .list_item{
                        width: 100%;
                        padding: 0.08rem;
                        box-sizing: border-box;
                        background-color: #fff;
                        // border-bottom: 0.08rem solid #eee;
                        margin-bottom: 0.08rem;
                        .list_item_name {
                          font-size: 0.24rem;
                        }
                        .list_item_num {
                          font-size: 0.2rem;
                          display: flex;
                          align-items: center;
                          justify-content: space-between;
                          color: #999;
                        }
                        &.active {
                          background-color: #31b158;
                          color: #fff;
                          .list_item_num{
                            color: #fff;
                          }
                        }
                    }
                }
            }
        }
    }
    .stock_right_box{
      width: calc(100% - 2rem);
      height: calc(100% - 0.1rem);
      margin-left: 0.1rem;
      margin-top: 0.1rem;
      // background-color: #fff;
      position: relative;
      .no_data{
        width: 100%;
        height: 100%;
        background-color: #fff;
        font-size: 0.2rem;
        display: flex;
        align-items: center;
        color: #858B9C;
        justify-content: center;
      }
    }
}
</style>

<style lang="less">
.stockIndex{
  .el-timeline-item__node{
    left: -0.05rem;
    width: 0.2rem;
    height: 0.2rem;
  }
  .el-timeline-item__timestamp.is-top{
    font-size: 0.2rem;
  }
  .el-timeline-item__content{
    font-size: 0.2rem;
  }
}
</style>